import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
import { reducer as notificationsReducer } from 'reapop'
import uiReducer from 'Features/ui/reducer'
import reducerRoom from './reducers/reducerRoom'
import reducerAuth from './reducers/reducerAuth'

export default combineReducers({
    form: formReducer,
    notifications: notificationsReducer(),
    ui: uiReducer,
    room: reducerRoom.room,
    auth: reducerAuth.auth,
})



// WEBPACK FOOTER //
// ./src/reducers.js